import { render, staticRenderFns } from "./GraphDetail37.vue?vue&type=template&id=65710d91&scoped=true"
import script from "./GraphDetail37.vue?vue&type=script&lang=js"
export * from "./GraphDetail37.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65710d91",
  null
  
)

export default component.exports